export * from './TreeView';
export * from './TreeItem/TreeItem';
export * from './model';
import { provideChameleonDesignSystem } from '../common/ChameleonDesignSystem';
import { chameleonTreeItem } from './TreeItem/TreeItem.definition';
import { chameleonTreeView } from './TreeView.definition';
provideChameleonDesignSystem().register(chameleonTreeView(), chameleonTreeItem());
